export default __webpack_public_path__ + "static/media/right-leafs.81943ff7.svg";